import React, { Component } from 'react';
import cx from 'classnames';
import Dropdown from 'components/common/Dropdown';
import Menu from 'components/common/Menu';

import s from '../styles';
import { withTranslation } from 'react-i18next';

class Filters extends Component {
  render() {
    const {
      priceFrom,
      priceTo,
      areaFrom,
      areaTo,
      handleChange,
      handleDropdownClick,
      interiors,
      interior,
      t,
      currency
    } = this.props;
    return (
      <div className={s.FlatsFilters}>
        <div className={s.FlatsFilter}>
          <label htmlFor="price-from">
            {t('components.flatsList.filters.price', { currency })}
          </label>
          <div className={s.FlatsFilterInputs}>
            <div className={s.InputWrap}>
              <input
                type="text"
                id="price-from"
                name="priceFrom"
                value={priceFrom || ''}
                className={cx(s.Input, s.InputPrice, { [s.Filled]: priceFrom })}
                onChange={handleChange}
              />
              <span className={s.Prefix}>
                {t('components.flatsList.filters.from')}
              </span>
            </div>
            <div className={s.InputWrap}>
              <input
                type="text"
                name="priceTo"
                value={priceTo || ''}
                className={cx(s.Input, s.InputPrice, { [s.Filled]: priceTo })}
                onChange={handleChange}
              />
              <span className={s.Prefix}>
                {t('components.flatsList.filters.to')}
              </span>
            </div>
          </div>
        </div>
        <div className={s.FlatsFilter}>
          <label htmlFor="area-from">
            {t('components.flatsList.filters.area')}
          </label>
          <div className={s.FlatsFilterInputs}>
            <div className={s.InputWrap}>
              <input
                type="text"
                id="area-from"
                name="areaFrom"
                value={areaFrom || ''}
                className={cx(s.Input, s.InputArea, { [s.Filled]: areaFrom })}
                onChange={handleChange}
              />
              <span className={s.Prefix}>
                {t('components.flatsList.filters.from')}
              </span>
            </div>
            <div className={s.InputWrap}>
              <input
                type="text"
                name="areaTo"
                value={areaTo || ''}
                className={cx(s.Input, s.InputArea, { [s.Filled]: areaTo })}
                onChange={handleChange}
              />
              <span className={s.Prefix}>
                {t('components.flatsList.filters.to')}
              </span>
            </div>
          </div>
        </div>
        <div className={cx(s.FlatsFilter, s.Interior)}>
          <label>
            {t('components.flatsList.filters.interior')}
          </label>
          <Dropdown
            className={cx(s.DropdownInterior)}
            buttonStyle={s.DropdownInteriorButton}
            textStyle={s.DropdownInteriorText}
            iconStyle={s.DropdownInteriorIcon}
            text={interiors[interior]}
            topShift
          >
            <Menu noArrow pure className={s.DropdownInteriorMenu}>
              {
                ['all', 'chernInt', 'chistInt', 'predChistInt', 'remInt', 'chastRemInt'].map(
                  (key) =>
                    <span onClick={() => handleDropdownClick(key)} className={s.InteriorMenuItem} key={key}>
                      {interiors[key]}
                    </span>
                )
              }
            </Menu>
          </Dropdown>
        </div>
        {/* <div className={cx(s.FlatsFilter, s.Interior)}>
          <label>Корпус</label>
          <Dropdown
            className={cx(s.DropdownInterior)}
            buttonStyle={s.DropdownInteriorButton}
            textStyle={s.DropdownInteriorText}
            iconStyle={s.DropdownInteriorIcon}
            text={(pavilions.find(({ id }) => id === pavilion) && pavilions.find(({ id }) => id === pavilion).name) || "Не важно"}
            topShift
          >
            <Menu noArrow pure className={s.DropdownInteriorMenu}>
              {
                pavilions.map(
                  ({ id, name }) =>
                  <span onClick={() => handlePavilionChange(id)} className={s.InteriorMenuItem} key={id}>
                    Корпус {name}
                  </span>
                )
              }
            </Menu>
          </Dropdown>
        </div> */}
      </div>
    );
  }
}

export default withTranslation()(Filters);



// WEBPACK FOOTER //
// ./src/components/FlatsList/Filters/Filters.js